<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="profile-page">

        <!-- PROFILE HEADER -->
        <div class="profile-header">
            <div class="relative">
                <!--<div class="cover-container rounded-t-lg">
                    <img :src="require(`@/assets/images/profile/user-uploads/${userCoverImg}`)" alt="user-profile-cover" class="responsive block">
                </div>-->
                <div class="cover-container rounded-t-lg"></div>
                <div class="profile-img-container pointer-events-none">
                    <div>
                        <vs-avatar class="user-profile-img" :src="this.userInfo.logo" size="85px" />
                    </div>
                    <div class="profile-actions pointer-events-auto flex">
                        <vs-button @click="tab = 'edit'" icon-pack="feather" radius icon="icon-edit-2"></vs-button>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-end flex-wrap profile-header-nav p-6">

                <div class="block sm:hidden">
                    <feather-icon @click="isNavOpen = !isNavOpen" icon="AlignJustifyIcon" v-show="!isNavOpen" class="vx-navbar-toggler" />
                    <feather-icon icon="XIcon" v-show="isNavOpen" @click="isNavOpen = !isNavOpen" class="vx-navbar-toggler" />
                </div>
                <div :class="isNavOpen ? 'block': 'hidden'" class="w-full flex-grow sm:flex sm:items-center sm:w-auto">
                    <div class="text-sm sm:flex-grow">
                        <div class="vx-row">
                            <div class="vx-col lg:w-3/12"></div>
                            <div class="vx-col lg:w-6/12 text-center">
                                <a @click="tab = 'about'" :class="tab === 'about' ? 'active' : ''" class="router-link-exact-active router-link-active cursor-pointer tabLink">{{ $t('about') }}</a>
                                <a>&nbsp;&nbsp;&nbsp;&nbsp;</a>
                                <a @click="tab = 'prizes'" :class="tab === 'prizes' ? 'active' : ''" class="router-link-exact-active router-link-active cursor-pointer tabLink">{{ $t('prizes') }}</a>
                            </div>
                            <div class="vx-col lg:w-3/12"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <vx-navbar> -->
            <!-- </vx-navbar> -->
        </div>

        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/4"></div>

            <div class="vx-col w-full lg:w-1/2">

                <vx-card v-if="tab === 'about'" :title="$t('about')" class="mt-base">

                    <div>
                        <h6>{{ $t('CompanyName') }}:</h6><p>{{ userInfo.company_name }}</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('MPNID') }}:</h6><p>{{ userInfo.mpn_id }}</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('name') }}:</h6><p>{{ userInfo.name }}</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('emailAddress') }}:</h6><p>{{ userInfo.email }}</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('phone') }}:</h6><p>{{ userInfo.phone }}</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('FinCode') }}:</h6><p>{{ userInfo.fin_code }}</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('country') }}:</h6><p>Azerbaijan</p>
                    </div>
                    <div class="mt-5">
                        <h6>{{ $t('joined') }}:</h6><p>{{ userInfo.created_at }}</p>
                    </div>
                </vx-card>

                <vx-card v-else-if="tab === 'prizes'" :title="$t('MyPrizes')" class="mt-base">
                    <div class="vx-row pt-2">
                        <div class="vx-col w-1/2 sm:w-1/2 md:w-1/3 xl:1/4" v-for="(value, index) in prizes" :key="index">
                            <img :src="value.prize.image" alt="latest-upload" class="mb-4 user-latest-image responsive">
                        </div>
                    </div>
                </vx-card>

                <vx-card v-if="tab === 'edit'" :title="$t('ChangeInformation')" class="mt-base">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('CompanyName') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" :disabled="userInfo.type_id !== 1" v-model="saveInfo.company_name" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('MPNID') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" :disabled="userInfo.type_id !== 1" v-model="saveInfo.mpn_id" />
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('photo') }}</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                    <input type="file" name="logo" ref="logoChange" @change="logoChange" class="vs-inputx vs-input--input normal" style="border: 1px solid rgba(0, 0, 0, 0.2);">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('name') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" v-model="saveInfo.name" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('phone') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" v-model="saveInfo.phone" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('emailAddress') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" type="email" v-model="saveInfo.email" />
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('FinCode') }}</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" maxlength="7" v-model="saveInfo.fin_code" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('country') }}</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" value="Azerbaijan" disabled="disabled" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full"></div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-button color="success" type="filled" @click="saveProfile()">{{ $t('save') }}</vs-button>
                        </div>
                    </div>
                </vx-card>

                <vx-card v-if="tab === 'edit'" :title="$t('ChangePassword')" class="mt-base">

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('OldPassword') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" type="text" name="old_pass" v-model="changePass.old_pass"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('NewPassword') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full relative">
                            <vs-input class="w-full z-10" type="text" name="password" v-model="changePass.password"/>
                            <generate-pasword class="generate-local" :active="false" @get_password="getPassword"/>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('ConfirmNewPassword') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" type="text" name="password_confirmation" v-model="changePass.password_confirmation"/>
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full"></div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-button color="success" type="filled" @click="changePassword()">{{ $t('change') }}</vs-button>
                        </div>
                    </div>
                </vx-card>

            </div>

            <div class="vx-col w-full lg:w-1/4"></div>
        </div>
    </div>
</template>

<script>
import GeneratePasword from "../ui-elements/GeneratePasword";

export default {
    components: {
        GeneratePasword
    },
    data() {
        return {
            tab: 'about',
            isNavOpen: false,
            userInfo: window.userInfo,
            saveInfo : {
                company_name: '',
                mpn_id: '',
                logo: '',
                logoChange: '',
                name: '',
                phone: '',
                email: '',
                fin_code: '',
                _method: 'PUT'
            },
            changePass: {
                old_pass: '',
                password: '',
                password_confirmation: '',
                _method: 'PUT'
            },
            prizes: [],
            userLatestPhotos: ['user-01.jpg', 'user-02.jpg', 'user-04.jpg', 'user-03.jpg', 'user-05.jpg', 'user-06.jpg', 'user-07.jpg', 'user-08.jpg', 'user-09.jpg'],
        }
    },
    created() {
        this.saveInfo.company_name = this.userInfo.company_name;
        this.saveInfo.mpn_id = this.userInfo.mpn_id;
        this.saveInfo.logo = this.userInfo.logo;
        this.saveInfo.name = this.userInfo.name;
        this.saveInfo.phone = this.userInfo.phone;
        this.saveInfo.email = this.userInfo.email;
        this.saveInfo.fin_code = this.userInfo.fin_code;

        const thisIns = this;
        axios.get(apiUrl+'/prizes/my?token='+token)
            .then(function (response) {

                let data = response.data;
                if(data.code === 200){
                    thisIns.prizes = data.data;
                }else{
                    if (data.code === 401){
                        window.logout();
                    }
                    thisIns.$vs.notify({
                        title: 'Error',
                        text:  data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
            });
    },
    methods: {
        logoChange() {
            this.saveInfo.logoChange = '';
            if (this.$refs.logoChange.files.length > 0) {
                this.saveInfo.logoChange = this.$refs.logoChange.files[0];
            }
        },
        getPassword(value) {
            this.changePass.password = value;
            this.changePass.password_confirmation = value;
        },
        saveProfile(){
            this.$vs.loading();
            const thisIns = this;

            let sendData = new FormData();

            for (let index in thisIns.saveInfo) {
                let value = thisIns.saveInfo[index];
                sendData.append(index, value);
            }

            axios.post(apiUrl+'/profile?token='+token, sendData)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.$refs.logoChange.value = '';
                        thisIns.saveInfo.logoChange = '';

                        window.updateMyProfile();
                        thisIns.$vs.notify({
                            title: 'Success',
                            text: 'Success',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        });
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });

        },
        changePassword(){
            this.$vs.loading();
            const thisIns = this;

            axios.post(apiUrl+'/profile/password?token='+token, this.changePass)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.$vs.notify({
                            title: 'Success',
                            text: 'Success',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        });
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });

        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuesax/pages/profile.scss";
    #profile-page{
        .cover-container{
            height: 60px;
            background-image: url("../../assets/images/elements/profile_header.svg");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .tabLink{
            background: #F5F7FA 0% 0% no-repeat padding-box;
            border-radius: 2px;
            color: #4C70B5;
            padding: 12px 70px;
            font: Medium 12px/15px Montserrat;

            &.active{
                background: #FFFFFF 0% 0% no-repeat padding-box;
                box-shadow: 0px 3px 3px #4C70B51A;
                border-radius: 2px;
                cursor: default !important;
            }
        }
    }
</style>
